// extracted by mini-css-extract-plugin
module.exports = {"infotext":"tabfeedback_infotext__2DBXF","feedback":"tabfeedback_feedback__2Dh11","reset":"tabfeedback_reset__3E6IE"};